import Text from '@components/Text/Text';
import { Avatar, IconButton, styled } from '@mui/material';
import { lighten } from '@mui/system';
import { AvatarIconButtonType, AvatarSize } from './Avatar.types';

const getHeightWidthIconButton = (size: AvatarSize): React.CSSProperties => {
  if (size === 'large') {
    return { width: 30, height: 30, fontSize: 17 };
  } else if (size === 'medium') {
    return { width: 24, height: 24, fontSize: 13 };
  }
  return { width: 18, height: 18, fontSize: 10 };
};

const getAvatarHeightWidth = (size: AvatarSize): React.CSSProperties => {
  if (size === 'large') {
    return { width: 80, height: 80 };
  } else if (size === 'medium') {
    return { width: 40, height: 40 };
  }
  return { width: 32, height: 32 };
};

export const StyledAvatarContainer = styled(Avatar)<{ size: AvatarSize }>(
  ({ theme, size }) => ({
    background: theme.palette.secondary[100],
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    color: theme.palette.primary.dark,
    ...getAvatarHeightWidth(size),
  })
);

export const StyledAvatarText = styled(Text)(({ theme }) => ({
  color: theme.palette.primary.dark,
}));

export const StyledBadgeContent = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'iconButtonType' && prop !== 'size',
})<{
  iconButtonType: AvatarIconButtonType;
  size: AvatarSize;
}>(({ theme, iconButtonType, size }) => ({
  background:
    iconButtonType === 'add'
      ? lighten(theme.palette.primary.main, 0.85)
      : lighten(theme.palette.error.main, 0.85),
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  borderRadius: '100%',
  border: `2px solid`,
  borderColor: theme.palette.common.white,
  '&.MuiButtonBase-root:hover': {
    backgroundColor:
      iconButtonType === 'add'
        ? lighten(theme.palette.primary.main, 0.9)
        : lighten(theme.palette.error.main, 0.9),
  },
  '&.MuiButtonBase-root .MuiTouchRipple-child': {
    backgroundColor: theme.palette.grey[500],
  },
  ...getHeightWidthIconButton(size),
}));
